var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_111_309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3359 56.5C43.7093 56.5 56.1719 44.0374 56.1719 28.6641C56.1719 13.2907 43.7093 0.828125 28.3359 0.828125C12.9626 0.828125 0.5 13.2907 0.5 28.6641C0.5 44.0374 12.9626 56.5 28.3359 56.5Z",
    fill: "#2BE79A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8147 18.8481C32.8019 18.5742 23.8643 18.5753 19.857 18.8481C15.518 19.1443 15.0069 21.7653 14.9746 28.6641C15.0069 35.5508 15.5135 38.1829 19.857 38.4802C23.8654 38.753 32.8019 38.7541 36.8147 38.4802C41.1538 38.184 41.6648 35.563 41.6971 28.6641C41.6648 21.7775 41.1582 19.1454 36.8147 18.8481ZM24.9955 33.1179V24.2104L33.903 28.6563L24.9955 33.1179Z",
    fill: "#121418"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_111_309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55.6719,
    height: 55.6719,
    fill: "white",
    transform: "translate(0.5 0.828125)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.9411201c16ab7cfa599b4c1cc3b46c40.svg";
export { ForwardRef as ReactComponent };